// extracted by mini-css-extract-plugin
export default {"imageContainer":"B1-z","summaryPar":"C1-z","ratingCategories":"D1-z","reviewerInfo":"E1-z","reviewTypes":"F1-z","expanded":"G1-z"};